import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDatabase = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 12,
	viewBox: "0 0 10 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.83183 0.46663C0.91909 0.79261 0 1.40757 0 2.5V9C0 10.272 0.82099 11.0387 1.80304 11.4596C2.76871 11.8734 3.97221 12 5 12C6.02779 12 7.2313 11.8734 8.197 11.4596C9.179 11.0387 10 10.272 10 9V2.5C10 1.38411 9.0866 0.76764 8.165 0.44551C7.2142 0.11318 6.0255 0 5 0C3.96956 0 2.78135 0.12752 1.83183 0.46663ZM2.16817 1.40837C1.33091 1.70739 1 2.09243 1 2.5C1 2.93741 1.33658 3.32094 2.16498 3.61049C2.96417 3.88983 4.0255 4 5 4C5.9745 4 7.0358 3.88983 7.835 3.61049C8.6634 3.32094 9 2.93741 9 2.5C9 2.06259 8.6634 1.67906 7.835 1.38951C7.0358 1.11017 5.9745 1 5 1C4.03044 1 2.96865 1.12248 2.16817 1.40837ZM1 9C1 9.728 1.42901 10.2113 2.19696 10.5404C2.98129 10.8766 4.02779 11 5 11C5.97221 11 7.0187 10.8766 7.803 10.5404C8.571 10.2113 9 9.728 9 9V4.15934C8.741 4.32407 8.4534 4.45369 8.165 4.55449C7.2142 4.88682 6.0255 5 5 5C3.9745 5 2.78583 4.88682 1.83502 4.55449C1.54664 4.45369 1.25905 4.32407 1 4.15934V9Z",
		fill: "#5D6A85"
	})
});
export default SvgDatabase;
